import { TenantApiBase } from './base';

export class TenantPublicChargePaymentLinkApi extends TenantApiBase {
  getOrCreate(tenantId) {
    return super.get(`${tenantId}/link/get-or-create`, 'Failed to fetch link');
  }
}
